import { disableScrollToTopAction, enableScrollToTopAction } from "mrf/redux/actions/scrollToTop";
import { appDispatch } from "mrf/MRF";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

export const preventScrollToTop = () => {
    appDispatch.value(disableScrollToTopAction());
}

export default function useScrollToTop() {
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const scrollToTop = useSelector(state => state.scrollToTop);

    useEffect(() => {
        if (scrollToTop) {
            window.scrollTo(0, 0);
        } else {
            dispatch(enableScrollToTopAction());
        }
    }, [pathname]); // eslint-disable-line
}
